import { jsx as _jsx } from "react/jsx-runtime";
import DimensionFilterReactView from './dimensionFilterReactView';
import { ODataFunction, ODataOperator } from 'types/OData';
import { EventEmitter } from 'modules/shared/EventEmitter';
import { UserProperties } from 'modules/application/detail/users/models/UserProperties';
import DimensionFilterReactTranslations from './dimensionFilterReactTranslations';
import { useEffect, useState } from 'react';
import { UserFeatures } from 'modules/application/detail/users/UserFeatures';
import React from 'react';
const DimensionFilterReact = ({ filter, translateService, conditionDisabled, onChanges, }) => {
    const [comparisons, setComparisons] = useState([
        {
            value: ODataFunction.StartsWith,
            label: translateService.instantTranslate('utils.misc.odata.startsWith'),
        },
    ]);
    const [isUsingStartsWithOnContactsSearch, setIsUsingStartsWithOnContactsSearch] = useState(null);
    const [isContactTaxDocumentEnabled, setIsContactTaxDocumentEnabled] = useState(null);
    useEffect(() => {
        checkFeatures();
    }, []);
    const checkFeatures = async () => {
        setIsUsingStartsWithOnContactsSearch(await UserFeatures.isUsingStartsWithOnContactsSearch());
        setIsContactTaxDocumentEnabled(await UserFeatures.isContactTaxDocumentEnabled());
    };
    const getProperties = () => {
        return isContactTaxDocumentEnabled
            ? UserProperties.getPropsWithDocument()
            : UserProperties.getProps();
    };
    const mapUserProperties = () => {
        return (getProperties().map(key => ({
            key,
            name: translateService.instantTranslate(`utils.forms.${key}`),
        })));
    };
    const loadTranslations = () => {
        const translations = new DimensionFilterReactTranslations();
        translations.property = translateService.instantTranslate('utils.misc.property');
        translations.condition = translateService.instantTranslate('modules.analytics.dimensionFilter.condition');
        translations.value = translateService.instantTranslate('modules.analytics.dimensionFilter.value');
        return translations;
    };
    const loadComparisons = (selectedPropertyKey) => {
        let comparisons = isUsingStartsWithOnContactsSearch ?
            [
                {
                    value: ODataFunction.StartsWith,
                    label: translateService.instantTranslate('utils.misc.odata.startsWith'),
                },
            ]
            :
                [
                    {
                        value: ODataFunction.Contains,
                        label: translateService.instantTranslate('utils.misc.odata.contains'),
                    },
                    {
                        value: ODataFunction.NotContains,
                        label: translateService.instantTranslate('utils.misc.odata.notContain'),
                    },
                ];
        const propertyIsOnList = getProperties().indexOf(selectedPropertyKey) !== -1;
        if (propertyIsOnList) {
            comparisons = comparisons.concat({
                value: ODataOperator.Equals,
                label: translateService.instantTranslate('utils.misc.odata.equals'),
            });
            comparisons = comparisons.concat({
                value: ODataOperator.NotEquals,
                label: translateService.instantTranslate('utils.misc.odata.notEqual'),
            });
        }
        return comparisons;
    };
    const handleOnSelectedProperty = (propertyKey) => {
        setComparisons(loadComparisons(propertyKey));
    };
    const handleFilterChange = (propertyKey, comparison, value) => {
        filter.condition = comparison || null;
        filter.value = value || null;
        filter.property = propertyKey
            ? { key: propertyKey, name: translateService.instantTranslate(`utils.forms.${propertyKey}`) }
            : null;
        onChanges(EventEmitter({ changes: filter }));
    };
    const isNotValidValue = (selectedProperty, selectedValue) => {
        return selectedProperty && !selectedValue;
    };
    const isLoadingData = () => {
        return (isUsingStartsWithOnContactsSearch === null ||
            isUsingStartsWithOnContactsSearch === undefined ||
            isContactTaxDocumentEnabled === null ||
            isContactTaxDocumentEnabled === undefined);
    };
    return (_jsx(DimensionFilterReactView, { translations: loadTranslations(), userProperties: mapUserProperties(), comparisons: comparisons, conditionDisabled: conditionDisabled, handleOnSelectedProperty: handleOnSelectedProperty, handleFilterChange: handleFilterChange, isNotValidValue: isNotValidValue, isLoadingData: isLoadingData() }));
};
export default DimensionFilterReact;
